import React from 'react';
import { FichasData } from "../../data/fichas.data"
import icon3D from "../../assets/svgs/Icon_Download.svg";
import iconGallery from "../../assets/svgs/Icon_Gallery.svg";
import Icon_Back from "../../assets/svgs/Icon_Back.svg";
import useScreenOrientation from '../helpers/useScreenOrientation';

export default function SoloView3D({ product, color, setMenuView, isSidebarVisible = true}: any) {

  const isLandscape = useScreenOrientation();

  const DownloadPDF = (id: string) => {
    const fichasData: any = FichasData()
    const url = fichasData[id]
    const parts = url.split('/')
    const file = parts[parts.length - 1]
    const fileparts = file.split('.')
    var filename = file;
    if(fileparts.length > 2)
      filename = fileparts[0] + "." + fileparts[fileparts.length - 1]

    const a = document.createElement('a')    
    a.href = url
    a.target = '_blank'
    a.download = filename
    document.body.appendChild(a);
    a.click()
    document.body.removeChild(a);
  }

  return (
    <div className={`solo3dview-container ${isLandscape ? '' : 'portrait'}`}>

      { !isLandscape &&
        <div className={`solo3dview-toptitle ${isSidebarVisible ? '' : 'hidden'}`}>
          VISTA 3D
        </div>
      }
      <div className={`solo3dview-title ${isLandscape ? '' : 'portrait'}`}>
        Categoría - Cubierta
      </div>
      <div className={`solo3dview-subtitle ${isLandscape ? '' : 'portrait'}`}>
        PRODUCTO - {product.name.toUpperCase()}
      </div>

      <div className={`solo3dview-color-container ${isLandscape ? '' : 'portrait'}`}>
        <img className={`solo3dview-color-icon`} src={color.icon} alt=''/>
        <div className="solo3dview-color-container-text">
          <div className="solo3dview-color-name">
            {color.name}
          </div>
          <div className="solo3dview-color-info">
            {color.description}
          </div>
        </div>
      </div>

      <div className="solo3dview-button" onClick={() => DownloadPDF(product.id)}>
        <img className={`solo3dview-button-icon`} src={icon3D} alt=''/>
        <div className="solo3dview-button-text">
          Descargar Ficha Técnica
        </div>
      </div>
      <div className={`solo3dview-button`} onClick={() => setMenuView("GALERÍA")}>
        <img className={`solo3dview-button-icon`} src={iconGallery} alt=''/>
        <div className="solo3dview-button-text">
          Ver galería
        </div>
      </div>
      <div className="solo3dview-button" onClick={() => setMenuView("PERSONALIZA")}>
        <img className={`solo3dview-button-icon`} style={{transform: `rotate(90deg)`}} src={Icon_Back} alt=''/>
        <div className="solo3dview-button-text">
          Regresar a Proyectos
        </div>
      </div>

    </div>
  );
}
